export default function Plus({ className = "w-5 fill-current fill-ink" }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24">
      <path d="M13.5,0l-0.002,10.5H24v3H13.498L13.5,24h-3l-0.002-10.502L0,13.5v-3l10.498-0.002L10.5,0H13.5z" />
    </svg>
  )
}
